import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import brand from 'dan-api/dummy/brand';
import PapperBlock from 'dan-components/PapperBlock/PapperBlock';
import SearchForm from '../../../components/Forms/SearchForm';
import List from '../../../components/Lists/List';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import MySnackbar from '../../../components/Notification/StyledNotif';
import { connect } from 'react-redux';
import { onFetchIndexQaInformationAction } from '../../../redux/actions/qaInformation';
import { onFetchIndexQaCategoryAction } from "../../../redux/actions/qaCategory";
import accessToken from '../../../utils/accessToken';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../../components/Forms/user-jss';
import {enumToJa} from '../../../utils/format';
import Loading from '../../../components/Loading/index'
import NotFound from '../../NotFound/NotFound';

function Index(props) {
  const { classes } = props;
  const title = brand.name + ' - QA情報一覧';
  const description = brand.desc;
  const url = '/admin/qa_information/'
  const internalValues = props.internalValues;
  const [qaCategories, setQaCategories] = useState([]);
  // メッセージ関連
  const location = props.location
  const [notification, setNotification] = useState({
    openStyle: location.message ? true : false,
    message: location.message ? location.message : '',
    variant: location.message ? location.variant : 'info'
  });

  const displayNotification = (message , valiant ='error') => {
    setNotification({
      openStyle: true,
      message: message,
      variant: valiant
    });
  }

  useEffect(() => {
    props.onFetchIndexQaCategory({
      accessToken: accessToken(props),
      onSuccess: data => {
        setQaCategories(data.data);
      },
      onErrorWithNotice: error => {
        displayNotification("QAカテゴリを取得できませんでした")
      }
    })
  }, []);

  useEffect(() => {
    searchItems[0].menuItems = qaCategories ? qaCategories.map( (category) => ({key: category.attributes.name, value: category.id} )) : null
    setSearchItems(searchItems.slice())
  }, [qaCategories]);
  
  const [qaInformationData, setQaInformationData] = useState("")
  // 検索項目
  const [searchItems, setSearchItems] = useState(
    [
      { label: "カテゴリ名", name: "qa_category_id", value: "", formType: "select",
        menuItems: qaCategories ? qaCategories.map( (category) => ({key: category.attributes.name, value: category.id} )) : null
      },
      { label: "ステータス", name: "status", value: "", formType: "select", menuItems: [{key: '有効', value: '1'}, {key: '無効', value: '2'}]},
    ]
  )

  const [listItems, setlistItems] = useState(
    [
      { label: "QAカテゴリ名" , name: 'qa-category'},
      { label: "QA管理名称" , name: 'name'},
      { label: "ステータス" , name: 'status', format: (value)=>{return enumToJa(value['status'])}}
    ]
  )
  // 一覧
  const [loading, setLoading] = useState(true);

  const submitForm = (values, page = 1) => {
    let data = {}
    searchItems.forEach(item => { data[item.name] = item.value})
    data.page = page
    props.onFetchIndexQaInformation({
      accessToken: accessToken(props),
      data: data,
      onSuccess: data => {
        const item = data
        setQaInformationData(item)
        item.data.length == 0 ? noData() : setLoading(false)
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  }; 

  const noData = () => {
    displayNotification('検索結果がありませんでした', 'warning')
  }

  const changeValue = (index,value) => {
    searchItems[index].value = value
    setSearchItems(searchItems.slice())
  }

  return (
    <React.Fragment>
      {internalValues.role === 'company' ? <NotFound /> :
        <div>
          <Helmet>
          <title>{title}</title>
          </Helmet>
          <PapperBlock title="QA情報検索" whiteBg icon="ios-search-outline" desc="">
            <section className={classes.formWrap}>
              <Grid container spacing={3}>
                { searchItems.map( (item, index) => {
                  return(
                    <Grid key={index} item xs={12} sm={6}>
                      <SearchForm searchItem={item} key={index} id={index} changeValue={changeValue} role={props.internalValues.role} />
                    </Grid>
                  )}
                )}
              </Grid>
            </section>
              <div className={classes.btnArea}>
                <Button variant="contained" color="primary" size="large" onClick={submitForm}>
                  検索
                </Button>
              </div>
          </PapperBlock>
          {/*検索を開始するまでは一覧は表示しない
            検索を開始し、QA情報一覧APIが終了するまではローディング画面
            QA情報一覧APIが終了し、データが格納されている場合は一覧を表示
            QA情報一覧APIが終了し、データが格納されていない場合は一覧は表示しない*/}
          {loading || qaInformationData.data.length === 0 ? "" :
            <PapperBlock title="QA情報一覧" whiteBg icon="ios-list"desc="">
              { props.loadingQaInformationIndex ? 
                <div><List listItems={listItems} searchResult={qaInformationData} url={url} submitForm={submitForm}/><Loading /></div> :
                <div><List listItems={listItems} searchResult={qaInformationData} url={url} submitForm={submitForm}/></div>
              }
            </PapperBlock>
          }
          <MySnackbar onClose={() => setNotification({...notification, openStyle: false})} notification={notification} />
        </div>
      }
    </React.Fragment>
  );
}
Index.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => {
  return {
    internalValues: state.getIn(['internalReducers', 'internalValues']),
    loadingQaInformationIndex: state.getIn(['qaInformationReducers', 'loadingQaInformationIndex']),
    loadingQaCategoryIndex: state.getIn(['qaCategoryReducers', 'loadingQaCategoryIndex']),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onFetchIndexQaInformation: data => {
      dispatch(onFetchIndexQaInformationAction(data));
    },
    onFetchIndexQaCategory: data => {
      dispatch(onFetchIndexQaCategoryAction(data));
    }
  };
};
const FormInit = connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
export default withStyles(styles)(withCookies(withRouter(FormInit)));